export default function changeStatusReducer (state = false, action) {
    switch (action.type) {
      case 'SET_CHANGE_STATUS':
        return action.payload;
      default:
        return state;
    }
  }
  